// extracted by mini-css-extract-plugin
export var columnList = "_dq-0";